import React, { useRef, useState } from 'react'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  Table,
  Button
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import CategoryForm from './components/CategoryForm'
import axios from 'axios'

const Category = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [categories, setCategories] = useState([])

  async function fetchCategories() {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_ENDPOINT + `/category/all`
      )
      setCategories(res.data.data)
    } catch (err) {
      console.log(err)
    }
  }

  async function updateCategory(data) {
    const token = localStorage.getItem('user-token')
    const authorizationHeader = token ? token : ''
    try {
      await axios.put(
        process.env.REACT_APP_API_ENDPOINT + `/category/updateCategory`, data, {
          headers: {
            Authorization: authorizationHeader
          }
        })
    } catch (err) {
      console.log(err)
    }
  }

  useDeepEffect(() => {
    fetchCategories()
  }, [])

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await fetchCategories()
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await updateCategory(data)
    }
    await fetchCategories()
    await setVisible(false)
    await setFormData({})
  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  return (
    <Card
      title="Category">
      <Table
        scroll={{ x: 1000 }}
        rowKey={(record) => record.id}
        dataSource={categories}
        columns={columns}
      />
      <CategoryForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(Category)


// WEBPACK FOOTER //
// ./src/pages/Category/index.js